import { createContext } from "react"

export type FiscalOverviewByYearContextType =
	| { type: "custom"; from: string; to: string }
	| { type: "year"; year: string }

export const FiscalOverviewByYearContext =
	createContext<FiscalOverviewByYearContextType>(null!)
